import React from 'react';
import OtcAuthCallback from "../../components/user/OtcAuthCallback";

const OtcAuthCallbackPage = (props) => (
    <OtcAuthCallback {...props} />
);

export default OtcAuthCallbackPage;